import React from 'react';
import Typography from '@mui/material/Typography';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {red, blue} from '@mui/material/colors';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import Button from "@mui/material/Button";
import TableWithDictData from "./tableView2";

function CSVFile(props) {
    let csvFile = props.data;

    return (
        <Card sx={{minWidth: 275}} key={csvFile._id} variant="outlined">
            <CardContent>
                <Typography variant="h5" component="div">
                    {csvFile.file_path.substring(csvFile.file_path.lastIndexOf('/') + 1)}
                </Typography>
                <Typography sx={{mb: 1.5}} color="text.secondary">
                    file_path: {csvFile.file_path}
                </Typography>
                <Typography sx={{mb: 1.5}} color="text.secondary">
                    file_size: {csvFile.file_size}
                </Typography>
                <Typography sx={{mb: 1.5}} color="text.secondary">
                    original URL: {csvFile.url}
                </Typography>
                <Typography sx={{mb: 1.5}} color="text.secondary">
                    Table ID: {csvFile._id}
                    <Button variant="outlined" sx={{marginLeft: '10px'}} onClick={() => {navigator.clipboard.writeText(csvFile._id)}}>Copy ID</Button>
                </Typography>
                <Typography sx={{mb: 1.5}} color="text.secondary">
                    Downloaded: {csvFile.downloaded ? <CheckIcon sx={{color: blue[500]}}/> :
                    <ClearIcon sx={{color: red[500]}}/>}
                    isFullDownloaded: {csvFile.isFullDownloaded ?
                    <CheckIcon sx={{color: blue[500]}}/> :
                    <ClearIcon sx={{color: red[500]}}/>}
                </Typography>

                <TableWithDictData csvfile_id={csvFile._id} />

            </CardContent>
        </Card>
    )

}

export default CSVFile;